/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { IAppConfig } from './app/services/models/app-config';
import { PersonType } from './app/services/models/enums';
import { bootstrapDatadogRum } from './app/services/observability';

// Register locales
registerLocaleData(localePtBr, 'pt-BR');
registerLocaleData(localeEs, 'es');

function getAppId(): string {
  let appId = new URLSearchParams(window.location.search).get('appId')
    ? new URLSearchParams(window.location.search).get('appId')
    : localStorage.getItem('appId');

  // TODO: Temporario - Remover
  // Força aautenticacção em DEV, PRE_HTML e HML.
  const host = window.location.hostname;
  const hostAppIdMap: { [key: string]: string } = {
    'portfolio-management-dev.npe.intl.br-use4.gcp.efx': 'f59abddc-fa43-4f23-8cc6-32337aeba94f',
    'portfolio-management-pre-qa.npe.intl.br-use4.gcp.efx': 'c85d91f1-94d3-4f14-93fe-5acf17c5cbb1',
    'portfolio-management-qa.npe.intl.br-use4.gcp.efx': '89a30540-c428-470a-bf26-0320ba704cdd',
    'uat.gerportfolio.equifax.com': '5991bced-9cf9-4fb5-8326-c2d19a4f3e46',
    'gerportfolio.equifax.com': '7b1ca188-9e66-4bcd-848f-e9db89e6ea35',
  };
  if (hostAppIdMap[host]) {
    appId = hostAppIdMap[host];
  }

  if (!appId?.trim() && host === 'localhost') {
    appId = 'd8e71839-4169-40a2-97bf-47e14d355388';
  }
  return appId;
}

function setEnvironmentAndFrequency(appId: string): string {
  let ambiente = 'LOCAL';
  const py = environment.country.py;
  const br = environment.country.br;
  const ambienteMap: { [key: string]: string } = {
    [py[0]]: 'LOCAL',
    [py[1]]: 'DEV',
    [py[2]]: 'PREHML',
    [py[3]]: 'HML',
    [py[4]]: 'UAT',
    [py[5]]: 'PROD',
    [br[0]]: 'LOCAL',
    [br[1]]: 'DEV',
    [br[2]]: 'PREHML',
    [br[3]]: 'HML',
    [br[4]]: 'UAT',
    [br[5]]: 'PROD',
  };
  if (ambienteMap[appId]) {
    sessionStorage.setItem('userFrequency', '1');
    ambiente = ambienteMap[appId];
  }
  return ambiente;
}

async function initialize() {
  if (environment.production) {
    enableProdMode();
  }

  const appId = getAppId();
  localStorage.setItem('appId', appId);

  const countryPY = environment.country.py.includes(appId);
  const countryBR = environment.country.br.includes(appId);
  const environmentName = setEnvironmentAndFrequency(appId);

  let country = 'BR';
  let url = 'br/main';

  if (countryPY) {
    country = 'PY';
    url = `py/main`;
  } else if (countryBR) {
    url = `br/main`;
  }

  const authConfig: IAppConfig = await environment.flag[environmentName][country];

  if (country != null) {
    localStorage.setItem('urlAssets', `${authConfig.appDomain}/assets`);
    localStorage.setItem('userCountry', country);
    localStorage.setItem('environment', environmentName);
    localStorage.setItem('personType', PersonType.COMPANY);
    const npe = authConfig.npe ? authConfig.npe : false;
    localStorage.setItem('npe', JSON.stringify(npe));
    const am = authConfig.adminModule ? authConfig.adminModule : false;
    localStorage.setItem('adminModule', JSON.stringify(am));

    sessionStorage.setItem('authConfig', JSON.stringify(authConfig));
    sessionStorage.setItem('postLoginRedirectUrl', `${authConfig.appDomain}/${url}`);

    // Datadog RUM boots before Angular so the SDK can patch fetch/XHR and capture first paint.
    // Currently a no-op in every environment until SRE provisions the RUM Application IDs.
    // PENDING: replace the hard-coded version with `${pkg.version}+${GIT_COMMIT.slice(0,7)}`
    // once the Jenkins source-maps stage is wired.
    bootstrapDatadogRum({
      authConfig,
      environmentName,
      hostname: window.location.hostname,
      version: '1.0.0',
    });

    platformBrowserDynamic()
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
      .catch((err) => console.error(err));
  }
}
initialize();
